let pending = null;

export const clearRegistrationPin = () => {
  pending = null;
};

export const setRegistrationPin = (pin) => {
  if (typeof pin !== "string" || !/^\d{4}$/.test(pin)) {
    clearRegistrationPin();
    throw new Error("กรุณาใส่ PIN 4 หลัก");
  }
  pending = { pin, confirmed: false };
};

export const hasRegistrationPin = () => pending !== null;

export const confirmRegistrationPin = (pin) => {
  if (!pending || pending.pin !== pin) return false;
  pending.confirmed = true;
  return true;
};

export const hasConfirmedRegistrationPin = () => pending?.confirmed === true;

export const consumeRegistrationPin = () => {
  const pin = hasConfirmedRegistrationPin() ? pending.pin : null;
  clearRegistrationPin();
  return pin;
};
